import React, { useContext, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { GRNContext } from "../Context/GRNContext";

import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Container,
  Button,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import { FaArrowLeft, FaClipboardList } from "react-icons/fa";

const pages = ["Home", "GRN Form", "GRN Records"];

function Header() {
  const { isAuthenticated, user, logout } = useContext(GRNContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElNav, setAnchorElNav] = useState(null);

  if (!isAuthenticated) return null;

  const isOnRecordsPage = location.pathname === "/records";
  const buttonText = isOnRecordsPage
    ? "Back to GRN Submission"
    : "Check GRN Records";

  const handleButtonClick = () => {
    navigate(isOnRecordsPage ? "/" : "/records");
  };

  const handleLogout = () => {
    logout();
    handleCloseUserMenu();
    navigate("/login");
  };

  const handleOpenUserMenu = (e) => setAnchorElUser(e.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);
  const handleOpenNavMenu = (e) => setAnchorElNav(e.currentTarget);
  const handleCloseNavMenu = () => setAnchorElNav(null);

  const userName = user?.name || "User";

  return (
    <AppBar position="static" style={{ background: "#424141" }}>
      <Container maxWidth="xl" style={{ padding: "0px 15px" }}>
        <Toolbar 
            disableGutters
             sx={{
                minHeight: "64px !important",   
                height: "64px !important",
                px: 1,                           
            }}
        >

          {/* LEFT: Logo */}
          <Typography
            variant="h6"
            noWrap
            component={Link}
            to="/"
            sx={{
              width: "20%",
              mr: 2,
              display: { xs: "none", md: "flex" },
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <img
              src="/images/plugin-logo.png"
              alt="plugin-logo"
              style={{ width: "100px", height: "50px" }}
            />
          </Typography>

          {/* CENTER TITLE */}
          <Box
            sx={{
              flexGrow: 1,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h5"
              noWrap
              component="div"
              sx={{
                fontFamily: "Open Sans",
                fontWeight: 700,
                color: "white",
              }}
            >
              GRN System
            </Typography>
          </Box>

          {/* ---------- MOBILE SECTION ---------- */}
          <Box sx={{ display: { xs: "flex", md: "none" }, gap: 1 }}>

            <Button
              variant="contained"
              color="primary"
              startIcon={isOnRecordsPage ? <FaArrowLeft /> : <FaClipboardList />}
              onClick={handleButtonClick}
              sx={{
                textTransform: "none",
                fontWeight: "bold",
                borderRadius: "12px",
                boxShadow: 2,
                background: "#fff",
                color: "#424141",
              }}
            >
              {buttonText}
            </Button>

            {/* Mobile Profile */}
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Tooltip title="Profile">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AccountCircleIcon style={{ color: "white", width: 45, height: 35 }} />
                </IconButton>
              </Tooltip>
              {user && (
                <Typography variant="caption" sx={{ color: "white", mt: 0.5 }}>
                  {userName}
                </Typography>
              )}
            </Box>

            {/* Mobile Menu Toggle */}
            <IconButton
              size="large"
              aria-label="menu"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />   {/* ✅ FIXED */}
            </IconButton>

            {/* Mobile Navigation Menu */}
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page}
                  onClick={() => {
                    handleCloseNavMenu();

                    // ROUTE FOR GRN TOOL
                    if (page === "Home") navigate("/");
                    else if (page === "GRN Form") navigate("/");
                    else if (page === "GRN Records") navigate("/records");
                  }}
                >
                  <Typography sx={{ textAlign: "center" }}>{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* ---------- DESKTOP SECTION ---------- */}
          <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 3 }}>

            <Button
              variant="contained"
              startIcon={isOnRecordsPage ? <FaArrowLeft /> : <FaClipboardList />}
              onClick={handleButtonClick}
              sx={{
                background: "#ffffff",
                color: "#424141",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "12px",
                boxShadow: 2,
              }}
            >
              {buttonText}
            </Button>

            {/* Profile Section */}
            <Box
                sx={{
                height: "48px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",

                }}
            >
              <Tooltip title="Profile">
                <IconButton onClick={handleOpenUserMenu}>
                  <AccountCircleIcon style={{ color: "white", width: 40, height: 35, }} />
                </IconButton>
              </Tooltip>

              <Typography 
                variant="caption" 
                sx={{ 
                    color: "white", 
                    width: "100px",
                    textAlign: "center",                    
                }}
                >
                {userName}
              </Typography>
            </Box>

            {/* Desktop Profile Menu */}
            <Menu
              sx={{ mt: "45px" }}
              anchorEl={anchorElUser}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={handleCloseUserMenu}>Account</MenuItem>
              <MenuItem onClick={handleCloseUserMenu}>Dashboard</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>

          </Box>

        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Header;
